import { memo } from 'react';
import { cn } from '@page/ui';
import { PageLogo } from '@page/icons';

import { IntroductoryRail } from '@page/core/components/onboarding/IntroductoryRail';
import { useIsNewUserStorage } from '@page/core/hooks/onboarding/useIsNewUserStorage';

interface ExternalLayoutProps {
  children: React.ReactNode;
  additionalContent?: React.ReactNode;
  className?: string;
  hideIntro?: boolean;
}

const ExternalLayoutBase = ({ children, additionalContent, className, hideIntro = false }: ExternalLayoutProps) => {
  const [isNewUser] = useIsNewUserStorage();

  return (
    <>
      <div className="flex min-h-[100vh] bg-bg-sur-secondary">
        <div className={cn('flex flex-col flex-1 items-center justify-center gap-14 px-14', className)}>
          <PageLogo className="h-8" />

          <div className="min-h-[60vh]">{children}</div>
        </div>

        {!hideIntro && isNewUser && <IntroductoryRail />}
      </div>

      {additionalContent}
    </>
  );
};

export const ExternalLayout = memo(ExternalLayoutBase);
